import React from "react";
import { useLocation, useParams } from "react-router-dom";
import "./ProfilePage.css";

import ProfileBanner from "./ProfileBanner";
import TopPicksRow from "./TopPicksRow";
type ProfileType = "recruiter" | "developer" | "stalker" | "adventure";

const ProfilePage: React.FC = () => {
  const location = useLocation();
  const backgroundGif =
    location.state?.backgroundGif ||
    "https://media.giphy.com/media/xT9IgzoKnwFNmISR8I/giphy.gif"; // Default GIF
  const { profileName } = useParams<{ profileName: string }>();

  const profile = ["recruiter", "developer", "stalker", "adventure"].includes(
    profileName!
  )
    ? (profileName as ProfileType)
    : "recruiter";
  return (
    <>
      <div
        className="profile-page"
        style={{ backgroundImage: `url(${backgroundGif})` }}
      >
        <ProfileBanner />
      </div>
      <TopPicksRow profile={profile} />
    </>
  );
};

export default ProfilePage;
